<template>
  <div class="card modal-card">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t(`detailClient.popupFusionTiers.${tiersTypeForTrad}.title`) }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <error-msg-component
        :error="error"
        :messages="messages"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields
      />
      <div class="">
        <div class="card">
          <header class="header-card">
            <p> {{ $t(`detailClient.popupFusionTiers.${tiersTypeForTrad}.tiersAFusionner`) }} </p>
          </header>
          <div class="card-content">
            <tiers-info :tiers="tiers"/>
          </div>
        </div>
        <div class="card mgt-20px">
          <header class="header-card">
            <p> {{ $t(`detailClient.popupFusionTiers.${tiersTypeForTrad}.tiersAConserver`) }} </p>
          </header>
          <div class="card-content">
            <tiers-autocomplete
              v-model="tiersAConserver"
              :societeActiveId="societeActiveId"
              :type="type"
              :sousTypes="sousTypes"
              :filteredItemFunc="filteredTiers"
              filterName="nomCommercialCompteComptable"
              :appendToBody="true">
              <template slot-scope="{ option }">
                <p>
                  <span v-if="option.code">{{ option.code }} </span>
                  <span>{{ option.nomCommercial }}</span>
                </p>
                <p class="is-size-8 is-italic">
                  <span v-if="option.compteComptable">{{ option.compteComptable }} </span>
                  <span>{{ option.adressePostaleLibelle }}</span>
                </p>
              </template>
            </tiers-autocomplete>
            <tiers-info
              v-if="tiersAConserver"
              :tiers="tiersAConserver"
            />
          </div>
        </div>
      </div>
      <footer class="buttons mgt-20px">
        <qd-button
          @click="$parent.close()"
          type="is-light"
          class="btn-modal-annuler">
          {{$t('general.button.cancel')}}
        </qd-button>
        <qd-button
          @click="popUpPrevention = true"
          :disabled="!tiersAConserver"
          class="button is-addOrEdit">
          {{$t('general.button.appliquer')}}
        </qd-button>
      </footer>
    </div>
    <b-modal
      v-model="popUpPrevention"
      :width="800"
      has-modal-card
      class="modal">
      <popUpPrevention
        v-if="tiersAConserver"
        :messHeader="msgPrevention"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPrevention = false"
        @yes="appliquer"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { fusionTiersAsync } from '@/api/tiers';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import TiersInfo from '@/components/clients/clients/fusionTiers/tiersInfo';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/tiers/translatorFusionTiers';
import validationFusionTiers from '@/services/tiers/validationFusionTiers';
import popUpPrevention from '@/components/general/popUpPrevention';
import { LISTE_SOUS_TYPE_FOURNISSEUR_ALL } from '@/configuration/tiers/tiersConf';
import tiersAutocomplete from '@/components/general/autocomplete/tiersAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popupFusionTiers',
  components: {
    errorMsgComponent,
    popUpPrevention,
    TiersInfo,
    tiersAutocomplete,
  },
  props: {
    tiers: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    sousTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    tiersTypeForTrad: {
      type: String,
      required: false,
      default: 'client',
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      popUpPrevention: false,
      tiersAConserver: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    msgPrevention() {
      return this.$t('detailClient.popupFusionTiers.msgPrevention', {
        tiersAFusionner: [this.tiers.code, this.tiers.nomCommercial]
          .filter(Boolean).join(' '),
        tiersAConserver: [this.tiersAConserver?.code, this.tiersAConserver?.nomCommercial]
          .filter(Boolean).join(' '),
      });
    },
  },
  methods: {
    filteredTiers(tiers) {
      return tiers.id !== this.tiers.id;
    },
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.popUpPrevention = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      try {
        await fusionTiersAsync({
          tiersAFusionnerId: this.tiers.id,
          tiersAConserverId: this.tiersAConserver.id,
        });
        messageSuccess(this.$i18n.t('detailClient.popupFusionTiers.success'));
        const config = LISTE_SOUS_TYPE_FOURNISSEUR_ALL
          .find(el => this.tiersAConserver.sousTypes.includes(el.code));
        this.$router.push({
          name: config.routeConsultation,
          params: { id: this.tiersAConserver.id, sousTypeFrom: this.sousTypes[0] },
        });
        this.$parent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationFusionTiers(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
